import { useEffect, useRef } from "react";

const FilterDropdown = ({ visible, options, onSelect, style, activateOutsideClick }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        activateOutsideClick?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activateOutsideClick]);

  return (
    visible && (
      <div
        ref={popupRef}
        className="w-[200px] bg-white border border-gray-300 rounded-md p-2 absolute z-10 shadow-lg text-gray-900"
        style={style}
      >
        <div className="w-full max-h-[150px] overflow-y-auto">
          {options.map((item, index) => (
            <div
              key={index}
              onClick={() => onSelect(item)}
              className="py-1 px-3 cursor-pointer hover:bg-themeColor hover:text-white rounded-md text-gray-900 text-[13px]"
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default FilterDropdown;
